<div
  [id]="id + '-item-' + value"
  #contentWrapper
  class="wrapper"
  [ngClass]="{ active: isActive }"
  (click)="onClick()"
>
  <ng-content></ng-content>
</div>
